import { ReactNode } from "react";
import styles from "./SetupInstructions.module.css";

export default function SetupInstructions({ header, children }: { header?: ReactNode; children: ReactNode }) {
	return (
		<div className={styles.wrapper}>
			{header}
			<div className={styles.instructions}>{children}</div>
		</div>
	);
}
